export default {
  // 边类型描述
  expandEdge: "这是扩展边",
  addressOwnership: "这是地址归属",
  sameIpAccount: "同ip账号",
  sameDeviceAccount: "同设备账号",

  // 字段标签
  sender: "发送方：",
  receiver: "接收方：",
  currencyName: "币种名称：",
  totalQuantity: "总数量：",
  transactionHash: "交易哈希：",
  transactionTime: "交易时间：",
  transactionQuantity: "交易数量：",
  total: "总数：",
  averageQuantity: "平均数量：",

  // 范围连接词
  to: "至",
};
